module.exports = __webpack_public_path__ + "static/media/5-min.jpg.0a82634b.webp";